






















import {Component, Prop, Watch} from 'vue-property-decorator';
import Vue from 'vue';
import {Toast} from '@/store/toast/toast.types';
import {Service, ServiceInitState} from '@/store/service/service.types';
import {SubService} from '@/store/subservice/subservice.types';
import {Action, State} from 'vuex-class';

@Component({
  components: {}
})
export default class SelServiceComponent extends Vue {
  @Prop({default: () => '' as string})
  public serviceId!: '';

  @Prop({default: () => '' as string})
  public CallSubServiceId!: '';

  @Prop({default: () => 0 as number})
  public index!: 0;

  @State('service') serviceState!: ServiceInitState;
  @Action('_getServiceForRegister', {namespace: 'service'}) getServiceForRegister!: () => Promise<void>;

  public serviceList = [{id: ''}] as Service[];
  public subServiceList = [{id: ''}] as SubService[];
  public nowServiceId = '';
  public nowSubServiceId = '';


  async mounted() {
    // console.log('SelServiceComponent', this.serviceId);
    await this.getServiceForRegister();
    this.serviceList = this.serviceState.service;
    this.nowServiceId = this.serviceId;
    this.nowSubServiceId = this.CallSubServiceId;
    this.findData(this.nowServiceId, this.serviceList);
  }


  async findData(serviceId: string, serviceList: Service[]) {
    console.log('SelServiceComponent', serviceId);
    if (serviceId) {
      let subList = serviceList.find((x) => x.id === serviceId);
      if (subList) {
        this.subServiceList = subList.subServices;
        console.log('subList', this.subServiceList);
      }
    }
  }

  async selService(e: { target: { value: string } }) {
    console.log(e.target.value)
    if (e.target.value) {
      let subList = this.serviceList.find((x) => x.id === e.target.value);
      if (subList) {
        this.subServiceList = subList.subServices
      }
    }
  }

  async selSubService(e: { target: { value: string } }) {
    await this.$emit('SubServiceChanged', {index: this.index, subServiceId: e.target.value});
  }


}
